import { useRef, useCallback } from 'react';

export function useDebounce() {
  const timeoutRef = useRef<number | null>(null);

  const createDebouncedFunction = useCallback(
    <T extends (...args: any[]) => any>(func: T, delay: number): T => {
      return ((...args: Parameters<T>): ReturnType<T> | void => {
        if (timeoutRef.current !== null) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
          func(...args);
        }, delay);
      }) as T;
    },
    []
  );

  return createDebouncedFunction;
}
